import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d85c016"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "home",
  "data-bs-theme": "light"
}
const _hoisted_2 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-container" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "taskWrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Create New Task from Task Template", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createElementVNode("p", null, " A Task template represents a repeatable task. When creating a new task from the template, the new task retains a reference to its template. Task templates are used within job templates to define the tasks needed for the job. ")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Task Template Details", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { class: "row my-1" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { for: "templateType" }, [
    /*#__PURE__*/_createTextVNode("Template Type"),
    /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*"),
    /*#__PURE__*/_createTextVNode(": ")
  ])
], -1))
const _hoisted_15 = { class: "col" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select a template", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 0,
  class: "row"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Select a task template to view details.", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Error: Unable to load task template.", -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "row my-1" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 my-1" }, "Template Name: ", -1))
const _hoisted_27 = { class: "col" }
const _hoisted_28 = { class: "row my-1" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 my-1" }, "Template Description: ", -1))
const _hoisted_30 = { class: "col" }
const _hoisted_31 = { class: "row my-1" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 my-1" }, "Template Work Center: ", -1))
const _hoisted_33 = { class: "col" }
const _hoisted_34 = { class: "row my-1" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 my-1" }, "Template Cost Center: ", -1))
const _hoisted_36 = { class: "col" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Task Details", -1))
const _hoisted_41 = { class: "input-group mb-3" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 input-group-text" }, [
  /*#__PURE__*/_createTextVNode("Task Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*")
], -1))
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = { class: "input-group mb-3" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 input-group-text" }, [
  /*#__PURE__*/_createTextVNode("Task Description "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*")
], -1))
const _hoisted_46 = ["onUpdate:modelValue"]
const _hoisted_47 = { class: "input-group mb-3" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 input-group-text" }, [
  /*#__PURE__*/_createTextVNode("Priority "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*")
], -1))
const _hoisted_49 = ["onUpdate:modelValue"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select Priority", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Low", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Medium", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "High", -1))
const _hoisted_54 = [
  _hoisted_50,
  _hoisted_51,
  _hoisted_52,
  _hoisted_53
]
const _hoisted_55 = { class: "input-group mb-3" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "col-3 input-group-text",
  for: "expectedStartDate"
}, [
  /*#__PURE__*/_createTextVNode("Expected Start "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*")
], -1))
const _hoisted_57 = ["onUpdate:modelValue"]
const _hoisted_58 = { class: "input-group mb-3" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "col-3 input-group-text",
  for: "expectedConclusionDate"
}, [
  /*#__PURE__*/_createTextVNode("Expected Conclusion "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*")
], -1))
const _hoisted_60 = ["onUpdate:modelValue"]
const _hoisted_61 = ["onClick"]
const _hoisted_62 = ["disabled"]

import { Task, Job, TaskTemplate } from '@/types/Ops';
import { fetchAllTaskTemplates, fetchAllJobs, postToUrl } from '@/api/api';
import { useJobStore } from '@/stores/Jobs';
import { useEmployeeStore } from '@/stores/UserEmployee';
import { ref, watch, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmployeeTaskCreation',
  setup(__props) {

const route = useRoute();
const isCreatingTask = ref(false);
const TaskTemplateId = ref(parseInt(route.params.templateId as string));
const allJobs = ref<Job[]>([]);
const selectedJobId = ref<number | null>(null);
const errorMsg = ref('');
const employeeStore = useEmployeeStore();
const allTaskTemplates = ref<TaskTemplate[]>([]);
const selectedTaskTemplateId = ref<number | null>(null);

const job = ref<Job>({
    id: 0,
    name: '',
    description: '',
    build_order_reference: '',
    tasks: [],
    work_center: null,
    completed_by: '',
    status: '',
});

const tasks = ref<Task[]>([
    {
        id: 0,
        name: '',
        description: '',
        employees: null,
        assignedEmployee: null,
        expected_start: '',
        expected_concluded: '',
        priority: 2,
    }
]);

const template = ref<TaskTemplate>({
    id: 0,
    name: '',
    description: '',
    work_center: null,
    cost_center: null,
    job_template: 0,
    job_template_order: 0
});

watch(() => route.params, (nextParam, lastParam) => {
    TaskTemplateId.value = parseInt(nextParam.templateId as string);
});

const clearErrorMsg = () => {
    errorMsg.value = '';
};

onMounted(async () => {
    try {
        allJobs.value = await fetchAllJobs();
        allTaskTemplates.value = await fetchAllTaskTemplates();
        const jobStore = useJobStore();
        await jobStore.getAllJobs();
        await employeeStore.fetch();
    } catch (error) {
        console.error("Error fetching jobs:", error);
    }
});


const updateDisplayedTaskTemplate = () => {
    const selectedTemplate = allTaskTemplates.value.find(t => t.id === selectedTaskTemplateId.value);
    if (selectedTemplate) {
        template.value = selectedTemplate;
    }
};

watch(selectedTaskTemplateId, (newVal, oldVal) => {
    if (newVal !== oldVal) {
        updateDisplayedTaskTemplate();
    }
});

const resetTask = () => {
    tasks.value = [
        {
            id: 0,
            name: '',
            description: '',
            employees: null,
            value: '',
            work_center: null,
            cost_center: null,
            job: 0,
            started: undefined,
            started_by: 0,
            concluded: undefined,
            concluded_by: 0,
            successful: false,
            conclusion_notes: '',
            events: [],
            perpetual: false,
            task_template: 0,
            job_order: 0,
            task: undefined,
            completed: '',
            expected_start: '',
            expected_concluded: ''
        }
    ];
};

const addTask = () => {
    tasks.value.push({
        id: 0,
        name: '',
        description: '',
        employees: null,
        assignedEmployee: null,
        expected_start: '',
        expected_concluded: '',
        priority: 2,
    });
};


const removeTask = (index: number) => {
    tasks.value.splice(index, 1);
};

const isFormValid = computed(() => {
    return tasks.value.every(task =>
        (task.name?.trim() || '') &&
        (task.description?.trim() || '') &&
        (task.expected_start?.trim() || '') &&
        (task.expected_concluded?.trim() || '') &&
        selectedTaskTemplateId?.value
    );
});

const createTasks = async () => {
    if (!isFormValid.value) {
        errorMsg.value = 'Please fill out all required fields for each task.';
        return;
    }

    isCreatingTask.value = true;
    try {
        for (const task of tasks.value) {
            // console.log(task);
            task.assignedEmployee = employeeStore.currentUser?.id;
            const newTask = {
                name: task.name,
                description: task.description,
                employees: task.assignedEmployee ? [task.assignedEmployee] : [],
                job: selectedJobId.value,
                expected_start: task.expected_start,
                expected_concluded: task.expected_concluded,
                created_by: employeeStore.currentUser?.id,
                priority: task.priority,
            };

            await postToUrl(`/ops/api/create-task/${selectedTaskTemplateId.value}/`, newTask);
        }
        alert(`Task has been successfully created`);
    } catch (error) {
        alert('Error occurred while creating tasks.');
    } finally {
        isCreatingTask.value = false;
        resetTask();
    }
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isCreatingTask.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      _hoisted_11,
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("span", _hoisted_15, [
          _withDirectives(_createElementVNode("select", {
            id: "templateType",
            class: "form-select",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTaskTemplateId).value = $event)),
            onChange: updateDisplayedTaskTemplate,
            style: {"--bs-bg-opacity":"0.9"},
            required: ""
          }, [
            _hoisted_16,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allTaskTemplates.value, (tmpl) => {
              return (_openBlock(), _createElementBlock("option", {
                key: tmpl.id,
                value: tmpl.id
              }, _toDisplayString(tmpl.name), 9, _hoisted_17))
            }), 128))
          ], 544), [
            [_vModelSelect, selectedTaskTemplateId.value]
          ]),
          (!selectedTaskTemplateId.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
            : _createCommentVNode("", true)
        ])
      ]),
      (!template.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
        : (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("span", _hoisted_27, _toDisplayString(template.value ? template.value.name : ''), 1)
            ]),
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("span", _hoisted_30, _toDisplayString(template.value ? template.value.description : ''), 1)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("span", _hoisted_33, _toDisplayString(template.value && template.value.work_center ? template.value.work_center.name : 'N/A'), 1)
            ]),
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("span", _hoisted_36, _toDisplayString(template.value && template.value.cost_center ? template.value.cost_center.name : 'N/A'), 1)
            ])
          ])),
      _hoisted_37,
      _hoisted_38,
      _hoisted_39,
      _hoisted_40,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tasks.value, (task, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("h3", null, "Task " + _toDisplayString(index + 1), 1),
          _createElementVNode("div", _hoisted_41, [
            _hoisted_42,
            _withDirectives(_createElementVNode("input", {
              class: "form-control task-name-input",
              type: "text",
              "onUpdate:modelValue": ($event: any) => ((task.name) = $event),
              required: ""
            }, null, 8, _hoisted_43), [
              [_vModelText, task.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control task-description-input",
              "onUpdate:modelValue": ($event: any) => ((task.description) = $event),
              required: ""
            }, null, 8, _hoisted_46), [
              [_vModelText, task.description]
            ])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": ($event: any) => ((task.priority) = $event),
              class: "form-select",
              required: ""
            }, _hoisted_54, 8, _hoisted_49), [
              [_vModelSelect, task.priority]
            ])
          ]),
          _createElementVNode("div", _hoisted_55, [
            _hoisted_56,
            _withDirectives(_createElementVNode("input", {
              id: "expectedStartDate",
              "onUpdate:modelValue": ($event: any) => ((task.expected_start) = $event),
              type: "date",
              class: "form-control",
              required: ""
            }, null, 8, _hoisted_57), [
              [_vModelText, task.expected_start]
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _hoisted_59,
            _withDirectives(_createElementVNode("input", {
              id: "expectedConclusionDate",
              "onUpdate:modelValue": ($event: any) => ((task.expected_concluded) = $event),
              type: "date",
              class: "form-control",
              required: ""
            }, null, 8, _hoisted_60), [
              [_vModelText, task.expected_concluded]
            ])
          ]),
          _createElementVNode("button", {
            class: "btn btn-danger remove-task-btn",
            onClick: ($event: any) => (removeTask(index))
          }, "Remove Task", 8, _hoisted_61)
        ]))
      }), 128)),
      _createElementVNode("button", {
        class: "btn btn-info add-task-btn",
        onClick: addTask
      }, "➕ Add Task"),
      _createElementVNode("button", {
        class: "btn btn-primary create-task-btn",
        onClick: createTasks,
        disabled: !isFormValid.value
      }, "Create Tasks", 8, _hoisted_62)
    ])
  ]))
}
}

})